'use client'

import { IBlog } from '@/constants/blogs'
import Author from './author'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'

export function BlogCard({ title, summary, name, date, avatar, cover, href }: IBlog & { href: string }) {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const imageUrl = `https://cdn.aitubiao.com/static/images/itubiao/blogs/cover/${encodeURIComponent(cover)}`
  const defaultImage = 'https://cdn.aitubiao.com/static/images/itubiao/blogs/cover/default.png'

  return (
    <Link href={href} className="block">
      <article className="group flex w-full min-w-80 cursor-pointer flex-col gap-6 rounded-xl p-6 transition duration-200 hover:-translate-y-2 hover:shadow-simple">
        <div className="relative aspect-[16/9] overflow-hidden rounded-2xl bg-gray-200">
          {isLoading && (
            <div className="absolute inset-0 animate-pulse bg-gray-300">
              <div className="h-full w-full bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
            </div>
          )}
          <Image
            src={hasError ? defaultImage : imageUrl}
            alt={title}
            fill
            sizes="(min-width: 1024px) 400px, (min-width: 768px) 50vw, 100vw"
            className={`object-cover transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => {
              setIsLoading(false)
              setHasError(false)
            }}
            onError={() => {
              setIsLoading(false)
              setHasError(true)
            }}
          />
        </div>

        <div className="space-y-4">
          <h1 className="line-clamp-2 text-2xl font-bold leading-tight text-foreground transition group-hover:text-primary md:text-2xl">
            {title}
          </h1>
          <p className="line-clamp-2 text-base font-[330] text-secondary">{summary}</p>
        </div>
        <Author name={name} date={date} avatar={avatar} />
      </article>
    </Link>
  )
}
